import { Identity, IPage } from "@amzn/ask-legal-domain";

export interface PageLiveDisplay {
    displayDate: Date;
    authorIdentity?: Identity;
}

/**
 * Selects the date/author for the live page's "Updated on" line: prefer the publish record
 * (publishedBy/publishedDate from load2), else fall back to the page's freshness/last-modified.
 */
export function selectPageLiveDisplay(output: IPage.LoadPageOutput): PageLiveDisplay {
    const displayDate = output.publishedDate
        ? output.publishedDate
        : (output.page.freshnessDate
            ? output.page.freshnessDate
            : output.page.lastModifiedDate);
    const authorIdentity = output.publishedBy ?? output.page.lastModifiedBy;
    return { displayDate, authorIdentity };
}
